import { Button } from "@/components/Primitives/Button/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/Primitives/Card/card"
import { MarkdownRenderer } from "@/components/Primitives/MarkdownRenderer/markdownRenderer"
import { cn } from "@/lib/utils/utils"

export interface QuestCardProps {
  id: string
  title: string
  description: string
  imageSrc: string
  imageAlt: string
  className?: string
  onContinue: () => void
  buttonText: string
  isActive?: boolean
}

export function QuestCard({
  title,
  description,
  imageSrc,
  imageAlt,
  onContinue,
  className,
  buttonText,
}: QuestCardProps) {
  return (
    <Card
      data-testid="quest-card"
      className={cn(
        "overflow-hidden bg-neutral-100 p-0 pb-4 lg:flex-row",
        className,
      )}
    >
      <div className="relative w-full h-48 lg:h-[25.75rem] lg:w-[45%]">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-4 lg:pt-10 lg:flex lg:flex-col lg:justify-between lg:w-[55%]">
        <div>
          <CardHeader>
            <CardTitle className="lg:text-[2.5rem]">{title}</CardTitle>
          </CardHeader>
          <CardContent>
            <MarkdownRenderer content={description || ""} />
          </CardContent>
        </div>
        <CardFooter className="justify-end lg:px-0 mt-6">
          <Button onClick={onContinue} type="button">
            {buttonText}
          </Button>
        </CardFooter>
      </div>
    </Card>
  )
}
